import loadable from '@loadable/component';
import React from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router';

import { NotFound } from 'src/modules/designStudio/components/NotFound';
import { useGetDesignStudioModelQuery } from 'src/shared/graphql/generated';
import { useLocation } from 'src/shared/hooks';
import { Route as Routes } from 'src/shared/route';

import { Mode } from '../../providers';

const DesignStudio = loadable(() => import('../DesignStudio'), {
  resolveComponent: module => module.DesignStudio,
});

const RedirectToFirstDesignStudioModel = () => {
  const { jobId } = useParams<{
    jobId: string;
  }>();
  const { search } = useLocation();
  const { data, loading } = useGetDesignStudioModelQuery({
    skip: !jobId,
    variables: {
      jobId: Number(jobId),
    },
  });

  if (loading) return null;

  const experienceUrl = data?.jobs.results[0]?.models[0].threeDExperience.url;
  if (!experienceUrl) return <NotFound />;
  // Construct a new url combining search params from the threeDExperience url and
  // the requested url.
  const redirectUrl = new URL(experienceUrl);
  const searchParams = new URLSearchParams(search);
  // Merges all search parameters.
  searchParams.forEach((value, key) => {
    redirectUrl.searchParams.append(key, value);
  });

  // Make sure to keep query parameters passed from the original url.
  // For example, share tokens need to persist in the redirect.
  return <Redirect to={`${redirectUrl.pathname}${redirectUrl.search}`} />;
};

const Router = () => (
  <Switch>
    <Route path={Routes.DESIGN_STUDIO_GUEST.path}>
      <DesignStudio mode={Mode.GUEST} />
    </Route>
    <Route path={Routes.DESIGN_STUDIO_PREVIEW.path}>
      <DesignStudio mode={Mode.PREVIEW} />
    </Route>
    <Route exact path={Routes.DESIGN_STUDIO_SHARE_VIEW.path}>
      <RedirectToFirstDesignStudioModel />
    </Route>
    <Route path={Routes.DESIGN_STUDIO_SHARE_MS_VIEW.path}>
      <DesignStudio mode={Mode.SHARE} />
    </Route>
    <Route exact path={Routes.DESIGN_STUDIO_EDIT.path}>
      <RedirectToFirstDesignStudioModel />
    </Route>
    <Route path={Routes.DESIGN_STUDIO_MS_EDIT.path}>
      <DesignStudio mode={Mode.DEFAULT} />
    </Route>
    <Route path={Routes.RENDERINGS_INTERACTIVE.path}>
      <DesignStudio mode={Mode.INTERACTIVE_RENDERING} />
    </Route>
    <Route path="*">
      <NotFound />
    </Route>
  </Switch>
);

export { Router };
